import * as React from 'react';
import { Placement } from '@floating-ui/react';
import { floatingContentStaticSide } from '../../../utils/floating-content-utils.tsx';
import { pixelToRem } from '../../../utils/style.ts';

/**
 * The width and height of the arrow in px.
 * Also defined in css (--FloatingArrow-size).
 */
export const floatingArrowSize = 5;

/**
 * The little arrow aka nose aka tip that floating elements have (e.g. tooltips).
 */
export const floatingArrow = (options: {
  arrowRef: React.Ref<HTMLDivElement>;
  x: number | undefined;
  y: number | undefined;
  placement: Placement;
}) => {
  const { arrowRef, x, y, placement } = options;
  const staticSide = floatingContentStaticSide(placement);

  return (
    <div
      ref={arrowRef}
      className="bg-sk-grey-0 absolute block rotate-45"
      style={{
        left: x != null ? `${pixelToRem(x)}rem` : '',
        top: y != null ? `${pixelToRem(y)}rem` : '',
        right: '',
        bottom: '',
        width: `${pixelToRem(floatingArrowSize)}rem`,
        height: `${pixelToRem(floatingArrowSize)}rem`,
        [staticSide]: `${pixelToRem(-0.5 * floatingArrowSize)}rem`
      }}
    />
  );
};
